import { SaleOrderItemsDto,SOItemsDto } from './sale-order-items.dto';
import { GlobalResponseObject } from '@gtpl/shared-models/common-models';


export class AllSoItemsResponseModel extends GlobalResponseObject {
    data?: SOItemsDto[];

    /**
     * 
     * @param status 
     * @param errorCode 
     * @param internalMessage 
     * @param data /SOItemsDto[]
     */
    constructor(status: boolean, errorCode: number, internalMessage: string, data?: SOItemsDto[]) {
        super(status, errorCode, internalMessage);
        this.data = data;
    }
}

 